var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 2,
  y: 2,
  fill: "#FF3C5F",
  rx: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.45 8.45a.68.68 0 0 1 .964 0L12 11.035l2.586-2.587a.682.682 0 1 1 .964.965L12.964 12l2.586 2.586a.682.682 0 0 1-.964.964L12 12.964 9.414 15.55a.682.682 0 0 1-.964-.964L11.036 12 8.45 9.414a.68.68 0 0 1 0-.965",
  clipRule: "evenodd"
})));
export default SvgReject;